module.exports = __webpack_public_path__ + "static/media/calendar-fill.e15aa75a.svg";